
import "./button"; // registers <leaselink-button>
import { LeaseLinkWidget } from "./widget-core";
import { Config } from "./types";

(window as any).leaseLinkWidget = new LeaseLinkWidget(
  (window as any).leaseLinkWidgetConfig as Config
);
